// extracted by mini-css-extract-plugin
export default {"nav":"NavBar_nav__qPXQL","nav__logo":"NavBar_nav__logo__bkeU7"};